import { atom, useAtom, useSetAtom } from 'jotai'
import { useEffect } from 'react'
import Mousetrap from 'mousetrap'

/** Global state for the command palette's visibility. */
const globalSearchOpenAtom = atom(false)

/** Read/write the palette's open state. Safe to use from multiple components. */
export const useGlobalSearchState = () => {
  const [isOpen, setIsOpen] = useAtom(globalSearchOpenAtom)
  return { isOpen, setIsOpen }
}

/**
 * Binds the palette's keyboard shortcut (⌘K on macOS, Ctrl+K elsewhere).
 * Call this exactly once — from the palette, which is mounted once at the
 * layout level — so the global Mousetrap binding isn't duplicated. `mod+k`
 * includes a modifier, so it fires even while focus is inside an input.
 */
export const useGlobalSearchKeyBinding = () => {
  const setIsOpen = useSetAtom(globalSearchOpenAtom)

  useEffect(() => {
    Mousetrap.bind('mod+k', () => {
      setIsOpen(prev => !prev)
      return false // Prevent the browser's default ⌘K behaviour.
    })

    return () => {
      Mousetrap.unbind('mod+k')
    }
  }, [setIsOpen])
}
